"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "What are the standard requirements to rent a property?",
  answer: <>
        We require a gross monthly income of at least 3x the monthly rent, a positive rental history, and a satisfactory credit and background check. You can review our full criteria on the{" "}
        <Link to="/TenantResources" className="text-primary underline underline-offset-4 font-medium hover:text-primary/80 transition-colors">
          Tenant Resources
        </Link>{" "}
        page before applying.
      </>
}, {
  question: "How much is the application fee and is it refundable?",
  answer: <>
        The application fee is $50 per adult applicant (18 years and older). This fee covers the cost of comprehensive background and credit checks and is strictly non-refundable once the processing has begun.
      </>
}, {
  question: "Do you accept pets in your rental properties?",
  answer: <>
        Pet policies vary by property as they are determined by the individual property owners. Please check the specific listing details on our{" "}
        <Link to="/AvailablePage" className="text-primary underline underline-offset-4 font-medium hover:text-primary/80 transition-colors">
          Available Properties
        </Link>{" "}
        page. If accepted, standard pet fees and deposits will apply.
      </>
}, {
  question: "How long does the application approval process take?",
  answer: <>
        Typically, applications are processed within 2-3 business days. To ensure the fastest processing time, please make sure all required documentation (pay stubs, government-issued ID, etc.) is submitted promptly with your initial application.
      </>
}, {
  question: "How do I submit my rental application?",
  answer: <>
        You can easily apply online through our secure portal. Find the property you are interested in on our{" "}
        <Link to="/AvailablePage" className="text-primary underline underline-offset-4 font-medium hover:text-primary/80 transition-colors">
          Available Properties
        </Link>{" "}
        page and click the "Apply Now" button directly on the listing to begin the process.
      </>
}, {
  question: "What is the standard security deposit amount?",
  answer: <>
        The standard security deposit is typically equal to one month's rent. However, this amount may vary based on the specific property and the results of your credit and background screening.
      </>
}];
export default function RentalApplicationFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="rental-application-faq" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 max-w-4xl">
        <div ref={ref} className={`bg-muted/40 rounded-2xl p-6 md:p-12 border border-border shadow-sm transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 tracking-tight">
              Rental Application FAQ
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Find quick answers to common questions about our application process, requirements, and policies.
            </p>
          </div>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i}>
                <AccordionTrigger className="text-primary font-bold text-left text-base md:text-lg hover:no-underline hover:text-primary/80 py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed text-base pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}